var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-show-all-tours"},[_c('nuxt-link',{staticClass:"el-button el-button--primary el-button--medium",attrs:{"to":`/search?type=${_vm.type}&value=${_vm.value}`},nativeOn:{"click":function($event){return _vm.handleLoading.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t(`general.show_more`)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }